/**
 * Authorization Roles
 */
export const authRoles = {
    admin: ['admin'],
    staff: ['admin', 'staff'],
    user: ['admin', 'staff', 'user', 'cc', 'sales', 'adminMedical', 'specialist'],
    sales: ['sales'],
    medical: ['adminMedical', 'specialist'],
    adminMedical: ['adminMedical'],
    cc: ['cc'],
    onlyGuest: ['guest']
};



// WEBPACK FOOTER //
// ./src/store/actionreducers/auth/auth.js